<template lang="pug">
  layout
    template(v-slot:toolbar)
      b-navbar
        //- Группы пользователей
        template(v-slot:start)
          .navbar-item
            b-field
              b-radio-button(v-for="tab in tabs" :key="tab.activeValue" v-model="filterActive" :native-value="tab.activeValue") {{ tab.label }}

        //- Actions
        template(v-slot:end)
          .navbar-item
            b-field
              b-button.is-primary(@click="createTest")
                b-icon(icon="plus")
                span Новый тест

    //- Content
    template(v-slot:content)

      b-table.is-clickable(:data="tabTests" :loading="tests.$state.loading" @click="onRowClick" hoverable)

        b-table-column(field="id" label="ID" width="30" numeric sortable v-slot="{row}") {{ row.id }}

        b-table-column(field="name" label="Название" sortable v-slot="{row}")
          b-icon(icon="clipboard-check-outline" type="is-blue")
          span  {{ row.name }}

        b-table-column(field="category" label="Категория" sortable v-slot="{row}") {{ row.category ? row.category.name : '-' }}

        b-table-column(field="questions" label="Кол-во вопросов" sortable v-slot="{row}") {{ row.questions.count() }}
        //-   b-switch(v-model="row.status" :true-value="1" :false-value="0" @input="row.$save()" :disabled="row.id==user.id")

        b-table-column(field="actions" label="Действия" width="30" v-slot="{row}")
          router-link.button.is-small.is-rounded(tag="button" :to="{name:'control.tests.edit', params:{id: row.id}}" exact)
            b-icon(icon="pencil-circle" type='is-info')
            span Редактировать

        //- Пусто
        template(v-slot:empty)
          section.section(v-if="tests.$state.loaded")
            .content.has-text-grey.has-text-centered
              p: b-icon(icon="emoticon-sad" size="is-large")
              p Нет записей
</template>

<script>
import Test from '@/models/Test';

export default {
  name: 'view-control-tests',

  data: () => ({
    tests: Test.collection(),
    filterActive: 1,
    tabs: [
      { label: 'Активные тесты', activeValue: 1 },
      { label: 'Неактивные тесты', activeValue: 0 },
    ],
  }),

  computed: {
    tabTests() {
      return this.tests.filter({ active: this.filterActive });
    },
  },

  methods: {
    onRowClick({ id }) {
      this.$router.push({ name: 'control.tests.edit', params: { id } });
    },
    createTest() {
      let test = new Test({ name: '-', need_scores: 0 });
      test.$save().then(({ data }) => {
        this.$router.push({
          name: 'control.tests.edit',
          params: { id: data.id },
        });
      });
    },
  },

  created() {
    this.tests.$fetch({ include: 'questions,category' });
  },
};
</script>
